import React from 'react';
import { Link } from 'react-router-dom';
import './MyAccountSubscriptions.css';
import './SubscriptionSuggestionCard.css';
import creditCardIcon from '../../../../images/Payment Methods/creditcard.png';
import paypalIcon from '../../../../images/Payment Methods/de_paypal.png';
import applePay from '../../../../images/Payment Methods/dmca 2-2.png';
import googlePay from '../../../../images/Payment Methods/dmca 2-1.png';
import klarnaIcon from '../../../../images/Payment Methods/klarna_dark.png';

type SuggestionCardCta =
  | { label: string; to: string; onClick?: () => void }
  | { label: string; to?: undefined; onClick: () => void };

interface SubscriptionSuggestionCardProps {
  theme?: 'mens' | 'general' | 'careplus';
  image: string;
  title: React.ReactNode;
  includesTitle?: string;
  benefits: React.ReactNode[];
  categoriesSection: React.ReactNode;
  paymentHeading: string;
  showKlarna: boolean;
  cta: SuggestionCardCta;
  ctaGradientDirection?: string;
}

const CheckmarkGlyph: React.FC = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path d="M2.5 6.3L4.7 8.5L9.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SubscriptionSuggestionCard: React.FC<SubscriptionSuggestionCardProps> = ({
  theme,
  image,
  title,
  includesTitle,
  benefits,
  categoriesSection,
  paymentHeading,
  showKlarna,
  cta,
  ctaGradientDirection,
}) => {
  const themeClassName = theme ? `subscription-suggestion-card--${theme}` : '';
  const rootStyle = ctaGradientDirection ? { '--suggestion-cta-gradient-direction': ctaGradientDirection } as React.CSSProperties : undefined;

  return (
    <div
      className={`subscription-category-card subscription-suggestion-card ${themeClassName} w-full bg-white border border-[#f1f5f9] rounded-[20px]`}
      style={rootStyle}
    >
      <div className="subscription-suggestion-card__top-row">
        <div className="subscription-category-card-header subscription-suggestion-card__hero" style={{ backgroundImage: `url(${image})` }} />
        <div className="subscription-suggestion-card__info-col">
          <p className="subscription-suggestion-card__title">{title}</p>
          <div className="subscription-suggestion-card__info-bottom">
            {categoriesSection}
            <div className="subscription-suggestion-card__payment">
              <h3 className="subscription-suggestion-card__section-heading">{paymentHeading}</h3>
              <div className="flex items-center flex-wrap" style={{ gap: '15px 20px' }}>
                <img src={creditCardIcon} className="w-[47px] h-[24px] object-contain" alt="" />
                <img src={googlePay} className="w-[47px] h-[24px] object-contain" alt="" />
                {showKlarna && <img src={klarnaIcon} className="w-[47px] h-[24px] object-contain" alt="" />}
                <img src={applePay} className="w-[47px] h-[24px] object-contain" alt="" />
                <img src={paypalIcon} className="w-[47px] h-[24px] object-contain" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="subscription-suggestion-card__includes">
        {includesTitle && <p className="subscription-suggestion-card__includes-title">{includesTitle}</p>}
        <ul className="subscription-suggestion-card__includes-list">
          {benefits.map((benefit, index) => (
            <li key={index}>
              <span className="subscription-suggestion-card__check-icon"><CheckmarkGlyph /></span>
              <span className="subscription-suggestion-card__check-text">{benefit}</span>
            </li>
          ))}
        </ul>
      </div>

      {cta.to
        ? (
          <Link to={cta.to} onClick={cta.onClick} className="subscription-suggestion-card__cta">
            {cta.label}
          </Link>
        )
        : (
          <button type="button" onClick={cta.onClick} className="subscription-suggestion-card__cta">
            {cta.label}
          </button>
        )}
    </div>
  );
};

export default SubscriptionSuggestionCard;
